import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { PermissionContext } from 'context/Context';

// Create a provider component
const PermissionProvider = ({ children }) => {
  const {permissions} = useSelector(state => state.profile_user.data || {});

  return (
    <PermissionContext.Provider value={{ permissions }}>
      {children}
    </PermissionContext.Provider>
  );
};

PermissionProvider.propTypes = { children: PropTypes.node };

export default PermissionProvider;